module.exports = __webpack_public_path__ + "static/media/santaReliquiaSlider2-2.70ed4b78.jpg";